var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHome01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m10 .476 9.3 7.44V19.3H.7V7.915zM2.3 8.684V17.7h15.4V8.685L10 2.524z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 13.5h5v1.6h-5z"
}))));
export default SvgIconHome01;